import { TableFilterBase } from "Hooks/Tables/useTableFiltration";

import Cookies from "universal-cookie";

export const storeHistoryFilter = (
  cookieName: string,
  historyFilter: string,
) => {
  new Cookies().set(cookieName, historyFilter, {
    path: "/",
    domain: process.env.REACT_APP_DOMAIN,
    expires: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() + 1,
    ),
  });
};

export const loadFilterFromCookies = <TFilter extends TableFilterBase>(
  cookieName: string,
): TFilter | undefined => {
  const cookie = getHistoryFromCookie(cookieName);

  if (!cookie || !cookie.filter) {
    return;
  }

  const historyFilter = cookie as TFilter;
  if (historyFilter) {
    return historyFilter;
  }
};

export const getHistoryFromCookie = (cookieName: string) => {
  return new Cookies().get(cookieName);
};
